import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Stack } from "@mui/material";
import Files from "files/components/Files";
import useFileTitle from "files/hooks/useFileTitle";
import { resolveObjectKey, useCurrentPath } from "files/hooks/useFiles";
import ScrollableTabContent from "~/components/ScrollableTabContent";
import useUser from "~/contexts/user";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import useFilePermissions from "~/hooks/useFilePermissions";
import useGlobalFileBrowserEnabled from "~/hooks/useGlobalFileBrowserEnabled";

const GlobalFilesView = () => {
  const user = useUser();
  const filePath = useCurrentPath();
  const location = useLocation();
  const enabled = useGlobalFileBrowserEnabled();
  const { isLoading: isLoadingFilePermissions } = useFilePermissions();
  const previewKey = location.state?.preview?.key;
  const fileKey = resolveObjectKey(previewKey ?? filePath, user?.email);
  const { title: currentFileTitle } = useFileTitle(fileKey);
  useDocumentTitle(filePath ? `${currentFileTitle} · Files` : "Files");
  // Note: App header is managed by DataBrowser parent component

  if (isLoadingFilePermissions) {
    return (
      <ScrollableTabContent bgcolor="common.dimmedPageBackground">
        <Stack alignItems="center" justifyContent="center" height="100%">
          <CircularProgress />
        </Stack>
      </ScrollableTabContent>
    );
  }

  if (!enabled) {
    return <Navigate to="/404" replace />;
  }

  return <Files />;
};

export default GlobalFilesView;
